const auth = (state = {
	token:'',
	wsStatus:false,
	loadedVisitors:false,
	hadConnection:false,
	isAuthenticated:false,
	currentAccount:false,
	user:{

	}
}, action) => {

	let newState = state;


	switch(action.type) {
		case 'UPDATE_SETTING_KEY':
			newState = {
				...state,
				user: {
					...state.user,
					settings:{
						...state.user.settings,
						[action.payload.key]:action.payload.value
					}
				}
			}
		break;
		case 'AUTH_SET_USER_KEY':
			newState = {
				...state,
				user: {
					...state.user,
					[action.payload.key]:action.payload.value
				}
			}
		break;
		case 'AUTH_SET_CONNECTION_STATUS':
			newState = {
				...state,
				wsStatus:action.payload,
				hadConnection:true
			}
		break;

        case 'AUTH_SET_LOADED_VISITORS':
            newState = {
                ...state,
                loadedVisitors:action.payload,
            }
            break;

		case 'AUTH_SET_CURRENT_ACCOUNT':
			localStorage.setItem('last_account_id',action.payload);

			newState = {
				...state,
				currentAccount:action.payload
			}
		break;
		case 'AUTH_SET_CURRENT_USER':
			if(action.payload.token == false) {
				newState = {
					...state,
					token:'',
					isAuthenticated:false,
					currentAccount:false,
					user:{}
				}
			}else{



				newState = {
					...state,
					token:action.payload.token,
					isAuthenticated:true,
					user:action.payload.user
				}


			}
		break;

	}

	return newState;
}



export default auth;



// WEBPACK FOOTER //
// ./reducers/authReducer.js